import React, { useState } from 'react';
import { logger } from '../../../core';

function ForgotPasswordForm({ onSwitchToLogin }) {
  const [formData, setFormData] = useState({
    email: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
    setMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    logger.log(
      { tags: 'section|auth|forgot-password', color1: 'cyan' },
      'Submitting forgot password request',
      { email: formData.email }
    );

    try {
      const response = await fetch('/api/account/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setMessage(result.message);
        logger.log(
          { tags: 'section|auth|forgot-password', color1: 'green' },
          'Forgot password request successful'
        );
      } else {
        setError(result.error || 'Request failed');
        logger.error(
          { tags: 'section|auth|forgot-password', color1: 'red' },
          'Forgot password request failed',
          { error: result.error }
        );
      }
    } catch (error) {
      setError('Network error. Please try again.');
      logger.error(
        { tags: 'section|auth|forgot-password', color1: 'red' },
        'Forgot password network error:',
        error
      );
    }

    setLoading(false);
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <div className="auth-header">
        <h1 className="auth-title">Reset Password</h1>
        <p className="auth-subtitle">Enter your email to receive a reset link</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}

      <div className="form-group">
        <label className="form-label" htmlFor="email">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          className="form-input"
          placeholder="you@example.com"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <button type="submit" className="form-button" disabled={loading}>
        {loading ? 'Sending...' : 'Send Reset Link'}
      </button>

      <div className="form-footer">
        Remember your password?{' '}
        <button
          type="button"
          className="form-link"
          onClick={onSwitchToLogin}
        >
          Sign in
        </button>
      </div>

      <style>{`
        .auth-form {
          width: 100%;
        }

        .auth-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .auth-title {
          font-size: 1.8rem;
          font-weight: 300;
          margin-bottom: 8px;
          background: linear-gradient(135deg, #ffffff 0%, #ff4444 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .auth-subtitle {
          font-size: 0.95rem;
          color: #999;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-label {
          display: block;
          margin-bottom: 8px;
          font-size: 0.9rem;
          color: #ccc;
          font-weight: 500;
        }

        .form-input {
          width: 100%;
          padding: 12px 16px;
          background: rgba(30, 30, 30, 0.6);
          border: 1px solid rgba(139, 0, 0, 0.3);
          border-radius: 8px;
          color: #fff;
          font-size: 0.95rem;
        }

        .form-input:focus {
          outline: none;
          border-color: #8b0000;
        }

        .form-input:-webkit-autofill,
        .form-input:-webkit-autofill:hover,
        .form-input:-webkit-autofill:focus,
        .form-input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 30px rgba(30, 30, 30, 0.6) inset !important;
          -webkit-text-fill-color: #fff !important;
          background: rgba(30, 30, 30, 0.6) !important;
          border: 1px solid rgba(139, 0, 0, 0.3) !important;
          border-radius: 8px !important;
          transition: background-color 5000s ease-in-out 0s !important;
        }

        .form-input:valid,
        .form-input:not(:placeholder-shown) {
          background: rgba(30, 30, 30, 0.6) !important;
          color: #fff !important;
          border-color: rgba(139, 0, 0, 0.3) !important;
        }

        .form-button {
          width: 100%;
          padding: 14px;
          background: linear-gradient(135deg, #8b0000, #ff4444);
          border: none;
          border-radius: 8px;
          color: white;
          font-size: 1rem;
          font-weight: 500;
          cursor: pointer;
          margin-bottom: 20px;
        }

        .form-button:hover:not(:disabled) {
          transform: translateY(-2px);
        }

        .form-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }

        .form-footer {
          text-align: center;
          font-size: 0.9rem;
          color: #999;
        }

        .form-link {
          color: #ff4444;
          background: none;
          border: none;
          cursor: pointer;
          text-decoration: underline;
          font-size: inherit;
        }

        .alert {
          padding: 12px 16px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 0.9rem;
        }

        .alert-error {
          background: rgba(220, 53, 69, 0.1);
          border: 1px solid rgba(220, 53, 69, 0.3);
          color: #f87171;
        }

        .alert-success {
          background: rgba(34, 197, 94, 0.1);
          border: 1px solid rgba(34, 197, 94, 0.3);
          color: #4ade80;
        }
      `}</style>
    </form>
  );
}

export default ForgotPasswordForm;